import { render, staticRenderFns } from "./base_modal.vue?vue&type=template&id=19f9f80e&scoped=true&"
import script from "./base_modal.vue?vue&type=script&lang=js&"
export * from "./base_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f9f80e",
  null
  
)

export default component.exports